import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { APP_ROUTES } from 'shared/constants';

export default function useRemoveCandidateTokenFromUrl() {
    const location = useLocation();

    useEffect(function removeCandidateTokenFromUrl() {
        const params = new URLSearchParams(location.search);
    
        if (params.has('candidateToken')) {
            params.delete('candidateToken');
            window.history.replaceState({}, '', [ `${ APP_ROUTES.basename }${ location.pathname }`, params.toString() ].filter(Boolean).join('?'));
        }
    }, [ location ]);
}
